import { Plugin } from '@nuxt/types'
import Pusher from 'pusher-js'

declare module '@nuxt/types' {
  interface Context {
    $pusher: Pusher
  }

  interface NuxtAppOptions {
    $pusher: Pusher
  }
}

const pusherPlugin: Plugin = ({ store, $config }, inject) => {
  const pusher = new Pusher($config.pusherApiKey!, {
    cluster: 'eu',
    channelAuthorization: {
      endpoint: `${$config.baseUrl}/v1.10/socket/auth`,
      transport: 'ajax',
      // Resolved on every auth request so subscriptions made after a login
      // or token refresh use the current token instead of the one captured
      // at the initial page load.
      headersProvider: () => ({
        Authorization: `Bearer ${store.state.auth.token}`,
        'Lambus-Secret': $config.lambusSecret,
      }),
    },
  })
  inject('pusher', pusher)
}

export default pusherPlugin
